import rpc from "@/rpc";

class LimitService {
    rpc

    constructor(rpc) {
        this.rpc = rpc
    }

    getLimit(id = null, cbuuid = null) {
        return this.rpc.execute('getLimit', {
            id: parseInt(id),
            cbUuid: cbuuid
        });
    }

    closeLimit(cbuuid, bureau) {
        return this.rpc.execute('closeLimit', {
            cbUuid: cbuuid,
            bureau: bureau
        });
    }
}

export default new LimitService(rpc)